import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import tabsReducer from './slices/tabsSlice'
import chatReducer from './slices/chatSlice'
import graphReducer from './slices/graphSlice'
import initiativesReducer from './slices/initiativesSlice'
import conversationsReducer from './slices/conversationsSlice'
import companiesReducer from './slices/companiesSlice'
import scenariosReducer from './slices/scenariosSlice'
import workspaceReducer from './slices/workspaceSlice'
import oracleReducer from './slices/oracleSlice'
import documentReducer from './slices/documentSlice'
import ivpReducer from './slices/ivpSlice'
import executionReducer from './slices/executionSlice'
import agencyReducer from './slices/agencySlice'
import vigilReducer from './slices/vigilSlice'
import onboardingReducer from './slices/onboardingSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tabs: tabsReducer,
    chat: chatReducer,
    graph: graphReducer,
    initiatives: initiativesReducer,
    conversations: conversationsReducer,
    companies: companiesReducer,
    scenarios: scenariosReducer,
    workspace: workspaceReducer,
    oracle: oracleReducer,
    document: documentReducer,
    ivp: ivpReducer,
    execution: executionReducer,
    agency: agencyReducer,
    vigil: vigilReducer,
    onboarding: onboardingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // For complex objects like graph data
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
